import createIcon from '../../createIcon';

/**
 * @component @name BugReport
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgOEgxNy4xOUMxNi43NCA3LjIyIDE2LjEyIDYuNTUgMTUuMzcgNi4wNEwxNyA0LjQxTDE1LjU5IDNMMTMuNDIgNS4xN0MxMi45NiA1LjA2IDEyLjQ5IDUgMTIgNUMxMS41MSA1IDExLjA0IDUuMDYgMTAuNTkgNS4xN0w4LjQxIDNMNyA0LjQxTDguNjIgNi4wNEM3Ljg4IDYuNTUgNy4yNiA3LjIyIDYuODEgOEg0VjEwSDYuMDlDNi4wNCAxMC4zMyA2IDEwLjY2IDYgMTFWMTJINFYxNEg2VjE1QzYgMTUuMzQgNi4wNCAxNS42NyA2LjA5IDE2SDRWMThINi44MUM3Ljg1IDE5Ljc5IDkuNzggMjEgMTIgMjFDMTQuMjIgMjEgMTYuMTUgMTkuNzkgMTcuMTkgMThIMjBWMTZIMTcuOTFDMTcuOTYgMTUuNjcgMTggMTUuMzQgMTggMTVWMTRIMjBWMTJIMThWMTFDMTggMTAuNjYgMTcuOTYgMTAuMzMgMTcuOTEgMTBIMjBWOFpNMTQgMTZIMTBWMTRIMTRWMTZaTTE0IDEySDEwVjEwSDE0VjEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BugReport = createIcon('BugReport', [
  [
    'path',
    {
      d: 'M20 8H17.19C16.74 7.22 16.12 6.55 15.37 6.04L17 4.41L15.59 3L13.42 5.17C12.96 5.06 12.49 5 12 5C11.51 5 11.04 5.06 10.59 5.17L8.41 3L7 4.41L8.62 6.04C7.88 6.55 7.26 7.22 6.81 8H4V10H6.09C6.04 10.33 6 10.66 6 11V12H4V14H6V15C6 15.34 6.04 15.67 6.09 16H4V18H6.81C7.85 19.79 9.78 21 12 21C14.22 21 16.15 19.79 17.19 18H20V16H17.91C17.96 15.67 18 15.34 18 15V14H20V12H18V11C18 10.66 17.96 10.33 17.91 10H20V8ZM14 16H10V14H14V16ZM14 12H10V10H14V12Z',
      key: 'tb79bk',
    },
  ],
]);

export default BugReport;
